import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'CountryCode' })
export class countrycodetoname implements PipeTransform {
  constructor() {}
  transform(value: any): any {
    if (value !== undefined && value !== null && value !== '') {
      try {
        const convertedCountry = JSON.parse(localStorage.CountryCollection).filter(data => data.CountryCode == value)[0].CountryNames[0].Name;
        return convertedCountry;
      } catch (ex) {
        console.log(ex + '-----' + value);
      }
    }
    return value;
  }

  checkCountryObj(value: any): any {
    if (value !== undefined && value !== null && value !== '') {
      try {
        const convertedCountry = JSON.parse(localStorage.CountryCollection).filter(data => data.CountryCode == value)[0].CountryNames[0].Name;
        return convertedCountry;
      } catch (ex) {
        console.log(ex + '-----' + value);
      }
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/_pipe/country.ts